import { httpServices } from "@/services/http/httpServices";

export { httpServices };
export { loadAllPages, PAGE_ALL_PAGE_SIZE, PAGE_ALL_MAX_PAGES } from "@/services/pagination";
export type { PageKeySelector, PageLoader } from "@/services/pagination";
export const operationalServices = httpServices;
// Compatibility export for existing pages; the implementation is now HTTP-backed.
export { httpServices as mockServices };
export { ApiClientError, API_BASE_URL, apiRequest } from "@/services/http/client";
export type * from "@/services/contracts";
